// extracted by css-extract-rspack-plugin
export default {"textareaWrapper":"Uu_pJ"};